import { useContext } from 'react';
import {
  GatewaySDKMap,
  PaymentCoordinatorContext,
  PaymentCoordinatorContextType,
} from '../../components-library/payment/PaymentCoordinator';
import { PaymentGateway } from '../../services/exports/Constants';

export function usePaymentCoordinator(): PaymentCoordinatorContextType;

export function usePaymentCoordinator<G extends keyof GatewaySDKMap>(
  gateway: G,
): Omit<PaymentCoordinatorContextType, 'paymentGatewaySDK'> & {
  paymentGatewaySDK: GatewaySDKMap[G];
};

export function usePaymentCoordinator(gateway?: PaymentGateway) {
  const context = useContext(PaymentCoordinatorContext);

  if (!context) {
    throw new Error('usePaymentCoordinator must be used inside PaymentCoordinatorProvider');
  }

  if (gateway) {
    return {
      ...context,
      paymentGatewaySDK: context.sdks[gateway] ?? { initialize: null },
    };
  }

  return context;
}
